<div class="not-found">
  <h1>{{ 'PAGE_NOT_FOUND' | translate }}</h1>
  <a [routerLink]="['/']">{{'RETURN' | translate}}</a>
</div>
